import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Dev-only: production HTML gets fb:app_id from postbuild (scripts/inject-fb-app-id.cjs).
 */
export const FbAppIdMeta: React.FC = () => {
  const id = process.env.REACT_APP_FACEBOOK_APP_ID?.trim();
  if (!id || process.env.NODE_ENV === "production") {
    return null;
  }
  return (
    <Helmet>
      <meta property="fb:app_id" content={id} />
    </Helmet>
  );
};
